import React, { forwardRef } from 'react'

export const Input = forwardRef((props, ref) => {
    const {
        hasError = false,
        errorMessage,
        disableHoverStyles = false,
        className = '',
        type,
        ...restProps
    } = props

    return (
        <>
            <input
                className={`h-[45px] w-full text-sm px-[15px] rounded border placeholder-opacity-50 placeholder-brand-black transition-color duration-200 disabled:cursor-not-allowed  ${
                    disableHoverStyles ? 'hover:bg-brand-white' : 'hover:bg-brand-light-grey'
                } ${hasError ? 'border-brand-danger' : 'border-brand-grey'} ${
                    errorMessage ? 'mb-[5px]' : ''
                } ${className}`}
                ref={ref}
                type={type}
                {...restProps}
            />

            {errorMessage && type !== 'hidden' && (
                <p className={`text-xs mt-0 mb-[15px] text-brand-danger block`}>{errorMessage}</p>
            )}
        </>
    )
})
